import Vue from "vue";
import ListSfFormatTypeRepository from "@/repositories/monocle/ListSfFormatTypeRepository";

export interface MonocleFormatType {
    uuid: string;
    label: string;
}

export default {
    state: {
        formatTypes: [],
    },
    mutations: {
        setMonocleFormatTypes: (
            state: any,
            formatTypes: MonocleFormatType[]
        ) => {
            Vue.set(state, "formatTypes", formatTypes);
        },
    },
    getters: {
        getMonocleFormatTypes: (state: any): MonocleFormatType[] => {
            return state.formatTypes;
        },
    },
    actions: {
        loadMonocleFormatTypes: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfFormatTypeRepository.get(params).then((data: any) => {
                    commit("setMonocleFormatTypes", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
